export default __webpack_public_path__ + "static/media/pat-apple-n.e8e4b58a.svg";